import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useNavigate} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useCreateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";

import * as statisticsItem2Api from "../../api/statisticsApi/statisticsItem2Api";
import * as Params from "../../models/clientModels/interfaces/apiParams";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {
  WOStatistics2,
  initializeStatistics2,
} from "../../models/serverModels/workOrder/WOStatistics2";
import {initializeStatisticsItem} from "../../models/serverModels/workOrder/WOStatisticsItem";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import StatisticsItem1Form from "./StatisticsItem1Form";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";

const item2Schema = yup.object({
  itemName: yup.string().required("아이템명을 입력해주세요"),
  displayOrder: yup.number(),
});

const CreateItem2 = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {mutate: createMutate, isLoading} = useCreateMutation<
    ResponseItem<WOStatistics2>,
    Params.Create<WOStatistics2>
  >({
    api: statisticsItem2Api.create,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("create");
        navigate("/Statistics");
        queryClient.invalidateQueries("statisticsCategoryList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });
  const methods = useForm<WOStatistics2>({
    defaultValues: initializeStatisticsItem,
    resolver: yupResolver(item2Schema),
  });

  const onSubmit: SubmitHandler<WOStatistics2> = (data) => {
    createMutate({
      token: tokenState,
      item: {...initializeStatistics2, ...data},
    });
  };
  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="항목 추가" />
      {isLoading && <MWProgress />}
      <FormSection>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <StatisticsItem1Form />
          <ConfirmButtonGroup link="/Statistics" cancelText="취소" confirmText="추가" />
        </form>
      </FormSection>
    </FormProvider>
  );
};

export default CreateItem2;
